<template>
<div v-if="service.meta.company.allow_subworkers && service.meta.canAssignContractorToBooking && subworkers.length > 0">
    <div class="form-group m-t-25-b-5-desktop"
         v-if="service.meta.company.allow_subworkers && service.meta.canAssignContractorToBooking">
        <div class="col-md-3 p-5-0">
            <label class="label-form inputs-header-font">
                SubWorker
            </label>
            <a v-if="!isContractor" href="javascript:;" @click="showSubWorkerInfo">
                <i class="fa fa-info-circle fa-lg"></i>
            </a>
        </div>
    </div>

    <div class="form-group sub-fieldworker-box"
         v-if="service.meta.company.allow_subworkers && service.meta.canAssignContractorToBooking">
        <div :class="{'col-lg-12':service.viewPage, 'col-lg-7':!service.viewPage,'col-md-12 p-5-0':true}">
            <select
                ref="subworker"
                class="form-control dropdown"
                :data-service-id="service.service_id"
                :name="`contractorSub_${signatureArray}`"
                multiple>
                <option></option>
                <option v-for="subworker in subworkers"
                        :key="subworker.contractor_subworker_id"
                        :value="subworker.contractor_subworker_id"
                        :selected="visit.subworkers.some(sw => subworker.contractor_subworker_id === sw.contractor_subworker_id)">{{ subworker.display_name }}</option>
            </select>
        </div>
    </div>
</div>
</template>

<script>
import {EventBus} from "@/events/event-bus";
import {getSubWorkers} from "@/modules/Services/api/appointments";
import alert from "bootstrap/js/src/alert";

export default {
    name: "AppointmentSubWorker",
    props: {

        visit: {
            type: Object,
            required: true
        },
        service: {
            type: Object,
            required: true
        },
        duplicate: {
          default() {
            return false
          }
        },
        index: {
            type: Number,
            default() {
                return 0;
            }
        },
    },
    data(){
      return {
          subworkers:[],
          callApi : false
      }
    },
    computed: {
        contractorId(){
            return this.visit.contractor_id
        },
        isContractor() {
            return this.service.meta.loggedUser.role_name === 'contractor'
        },
        signature() {
            return `${this.index}_${this.service.service_id}_${this.service.clone}`
        },
        signatureArray() {
            if (this.visit.id && this.duplicate == false){
                return `${this.visit.multiple_day_id}[]`
            }
            return `${this.service.service_id}_${this.service.clone}[${this.index}][]`
        },
    },
        methods: {
            showSubWorkerInfo() {
                window.subWorker_info()
            },
            getSubWorkers(contractor_id) {
                 if(contractor_id){
                getSubWorkers({contractor_id: contractor_id,from_admin_vue:true})
                    .then((response) => {
                        if (response.data.subworkers) {
                            // Handle the successful response here
                            this.subworkers = response.data.subworkers

                            if (!this.visit.booking_id || this.callApi) {
                                let contractorOfSubworkers = this.subworkers.find(subworker => subworker.contractor_subworker_id == contractor_id);
                                if (contractorOfSubworkers) {
                                    this.visit.subworkers.push(contractorOfSubworkers);

                                }
                            }
                        }
                        this.$emit('fieldworkerMounted');
                    })
                    .catch((error) => {
                        // Handle errors here
                        console.error("Error:", error.message);
                    });
                 }
            },

            addEventListeners(){

                EventBus.$on('selectContractorChange', (contractor_id,serviceId,clone,index) => {
                    if (this.service.service_id == serviceId && this.service.clone == clone && this.index == index){
                    this.getSubWorkers(contractor_id);
                    }
                })
            }

        },
        mounted() {
            this.addEventListeners();
        },
    updated() {
        $(this.$refs.subworker).select2({
            placeholder:"Select subworker"
        })
        $(this.$refs.subworker).on('change', (event) => {
            let selectedValue =  $(this.$refs.subworker).val();
            let vm = this
                vm.visit.subworkers = vm.subworkers
                .filter(subworker => selectedValue.includes(subworker.contractor_subworker_id.toString()));
        });

    },
    watch:{
        contractorId:function(newVal,oldVal){
          if (newVal !== oldVal){
              this.callApi = true;
          }
        }
    }

}
</script>

<style scoped>
.p-5-0 {
    padding: 0 0 0 5px;
}
.m-t-25-b-5-desktop {
    margin: 25px -15px 5px -15px;
}
/*For Laptop*/
@media (min-width: 1024px) and (max-width: 1439px) {
    .m-t-25-b-5-desktop {
        margin: 45px -15px 5px -15px;
    }
}
</style>